import { type FC, useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

interface Props {
  onClose: () => void
  permissionGroup: PermissionGroup
}

const EditModal: FC<Props> = ({ onClose, permissionGroup }) => {
  const [form] = useState(
    () =>
      new Form(
        {
          name: permissionGroup.attributes.name,
        },
        {
          name: 'string',
        }
      )
  )

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const { success } = await asyncAction(async () => form.save(permissionGroup))

    if (success) closePortal()
  }

  return (
    <Modal
      illustration="multiple-actions-upload"
      title={i18n.t('settings.permissions.edit.title', {
        name: permissionGroup.attributes.name,
      })}
      description={i18n.t('settings.permissions.edit.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={<Button submit>{i18n.t('settings.permissions.edit.submit')}</Button>}
    >
      <Text field={form.get('name')} label={i18n.t('settings.permissions.edit.label')} />
    </Modal>
  )
}

export default observer(EditModal)
